module.exports = __webpack_public_path__ + "img/yishi2.f41ec614.jpg";